module.exports = __webpack_public_path__ + "media/logo/logo_atrae-5532a7b7.png";